import React from 'react';
import {SwiperSlide} from 'swiper/react';

import AemComponent from '@/components/Aem/AemComponent/AemComponent';
import EditableText from '@/components/Aem/EditableText/EditableText';
import {AppButton} from '@/components/Button';
import {ADVANCED_DIAGNOSTICS_REMOVE_STICK_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import {getAriaLabel} from '@/services/accessibilityService';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import appRouterService from '@/services/route/appRouterService';

const AdvancedDiagnosticRemoveStickSlides = ({carouselData}) => {
    return carouselData.map((slideData, index) => (
        <SwiperSlide key={index}>
            <SlideComponent slideData={slideData} index={index} isLastSlide={carouselData.length - 1 === index} />
        </SwiperSlide>
    ));
};

const SlideComponent = ({slideData, isLastSlide}) => {
    const localizedStrings = getLocalizedStrings();
    const {title, description} = slideData;

    return (
        <div className='flex  w-full max-w-[361px] flex-col rounded-xl px-4 pb-6 text-primary ml:max-w-[370px]'>
            <div className='flex flex-col gap-3'>
                <h2 className='mb-0 text-16'>{localizedStrings[title]}</h2>
                <p className='text-16'>{localizedStrings[description]}</p>
            </div>
            {isLastSlide && (
                <AppButton
                    secondary
                    light
                    onClick={appRouterService.forwardToFittingConsumablesResolvedAD}
                    className='mt-6 w-full'
                    aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_REMOVE_STICK_BUTTON_ARIA_LABEL)}
                >
                    <AemComponent
                        component={EditableText}
                        pageName={routePaths.ADVANCE_DIAGNOSTIC}
                        itemName='removestickokbutton'
                    />
                </AppButton>
            )}
        </div>
    );
};

export default AdvancedDiagnosticRemoveStickSlides;
